
export default function AnchorBenefitsSection() {
  const benefits = [
    {
      title: '优质货源保障',
      subtitle: '20+独家品牌，500+产品SKU',
      description: '提供丰富的产品线，从入门级到收藏级应有尽有，满足不同观众需求，确保直播间产品丰富度。',
      features: ['独家品牌产品', '价格优势明显', '品质稳定可靠', '库存充足保障'],
      icon: 'ri-box-3-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/4af74fa167828490b611c538c370e926.jpg'
    },
    {
      title: '高额佣金回报',
      subtitle: '最高30%佣金比例',
      description: '业界领先的佣金政策，销售越多收益越高，还有额外奖励机制，让优秀主播获得更丰厚回报。',
      features: ['30%高额佣金', '月销量奖励', '年度分红计划', '无销售门槛'],
      icon: 'ri-money-dollar-circle-line',
      color: 'from-slate-500 to-slate-6',
      image: 'https://readdy.ai/api/search-image?query=Financial%20success%20concept%20with%20golden%20coins%20and%20money%2C%20profitable%20business%20growth%2C%20high%20earnings%20visualization%2C%20commission%20rewards%20system%2C%20successful%20partnership%20benefits%2C%20wealth%20accumulation%20imagery%2C%20golden%20financial%20elements&width=500&height=300&seq=benefit-02&orientation=landscape'
    },
    {
      title: '专业培训支持',
      subtitle: '茶叶知识+直播技巧',
      description: '提供系统性的茶叶知识培训和直播销售技巧指导，帮助主播快速成为茶叶专家，提升带货能力。',
      features: ['茶叶知识培训', '直播技巧指导', '话术模板提供', '定期技能提升'],
      icon: 'ri-graduation-cap-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Professional%20tea%20knowledge%20training%20session%2C%20expert%20instructor%20teaching%20about%20tea%20varieties%2C%20educational%20workshop%20environment%2C%20tea%20tasting%20and%20learning%20experience%2C%20professional%20development%20training%2C%20knowledge%20sharing%20atmosphere&width=500&height=300&seq=benefit-03&orientation=landscape'
    },
    {
      title: '全程运营支持',
      subtitle: '专业团队贴心服务',
      description: '配备专属客服团队，提供物流配送、售后服务、活动策划等全方位支持，让主播专注直播。',
      features: ['专属客服团队', '物流配送支持', '售后服务保障', '活动策划协助'],
      icon: 'ri-customer-service-line',
      color: 'from-gray-500 to-gray-600',
      image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20team%20providing%20comprehensive%20support%2C%20modern%20office%20environment%20with%20support%20staff%2C%20collaborative%20work%20atmosphere%2C%20service%20excellence%2C%20team%20cooperation%2C%20professional%20assistance%20environment&width=500&height=300&seq=benefit-04&orientation=landscape'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            合作优势
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            我们为主播提供全方位的支持和保障，让您专注于直播带货
          </p>
        </div>

        <div className="space-y-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-12`}
            >
              <div className="flex-1">
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              
              <div className="flex-1 space-y-6">
                <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${benefit.color} flex items-center justify-center mb-4`}>
                  <i className={`${benefit.icon} text-white text-2xl`}></i>
                </div>
                
                <div>
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-base md:text-lg text-blue-600 font-medium mb-4">
                    {benefit.subtitle}
                  </p>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed lg:text-lg mb-6">
                    {benefit.description}
                  </p>
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  {benefit.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-sm md:text-base text-gray-700">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Benefits */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold mb-4">更多福利政策</h3>
            <p className="text-sm md:text-base text-blue-100">我们为优秀主播提供更多成长机会和福利保障</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
                <i className="ri-trophy-line text-white text-2xl"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-3">月度之星奖励</h4>
              <p className="text-gray-600 leading-relaxed">
                月度销售之星额外奖励，包括现金奖励、品牌推广资源支持等丰厚回报
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-rocket-line text-white text-xl"></i>
              </div>
              <h4 className="text-sm md:text-base font-bold mb-2">流量扶持计划</h4>
              <p className="text-blue-100 text-xs md:text-sm">新主播享受3个月流量扶持，快速起步</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-gift-line text-white text-xl"></i>
              </div>
              <h4 className="text-sm md:text-base font-bold mb-2">节日活动支持</h4>
              <p className="text-blue-100 text-xs md:text-sm">重要节日提供特殊活动和营销物料支持</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
